// Unauthorized.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/dashboard'); // Home page ya jo bhi tumhara dashboard hai
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>403 - Unauthorized</h1>
      <p style={styles.message}>Sorry, you are not authorized to view this page.</p>
      <button style={styles.button} onClick={handleGoBack}>
        Go to Home
      </button>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f8f8',
    textAlign: 'center',
  },
  heading: {
    fontSize: '2rem',
    color: '#ff4d4f',
  },
  message: {
    fontSize: '1.2rem',
    margin: '20px 0',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#1890ff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default Unauthorized;
